import type { AnalystProgress, AnalystProgressStep } from '../../types';
import { t, type TranslationKey } from '../../i18n';

const STEP_KEYS: Record<AnalystProgressStep, TranslationKey> = {
  started: 'analystStarted',
  thinking: 'analystThinking',
  querying: 'analystQuerying',
  saving: 'analystSaving',
  fixing: 'analystFixing',
};

/** One live status line while the Data_Analyst sub-agent runs - a generic step text, never its queries or data. */
export function AnalystProgressLine({ progress }: { progress: AnalystProgress }) {
  const text = t(STEP_KEYS[progress.step]).replace('{round}', String(progress.round));
  return (
    <div className="analyst-progress" role="status" aria-live="polite">
      <span className="tool-call-spinner" />
      <span>{text}</span>
    </div>
  );
}
